<template>
  <v-card class="mx-auto overflow-auto border-radius0 height80" elevation="0">
    <v-card-title class="card-header text-left fixed-card-title2">
      <v-row>
        <v-col cols="10">
          <v-toolbar-title>{{ $t('edit') }} {{ $t('hospital') }}</v-toolbar-title>
        </v-col>
        <v-spacer></v-spacer>
        <v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <!-- Data -->
        <v-container>
          <v-row class="pt-2">
            <v-col class="d-flex pa-1" cols="12" sm="12">
              <v-text-field outlined hide-details="auto" dense v-model="handleHospitalName"
                :rules="[v => !!v || 'Item is required']" :label="$t('location-name')" required>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="12" sm="12">
              <v-select class="width-text-field2" hide-details dense v-model="handleMedicalInstitutionId"
                :items="allMedicalInstitutions" item-value="id" item-text="institutionName"
                :label="$t('medicalInstitution')" outlined @change="setSelectedOrganization"
                :menu-props="{ offsetY: true }">
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="12" sm="12">
              <v-textarea outlined hide-details dense no-resize v-model="handleDescription" :label="$t('description')">
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="12" sm="12">
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="12" sm="12">
              <div class="pt-4">
                <h5 class="heading text-left">{{ $t('address') }}</h5>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="12" sm="12">
              <v-text-field outlined hide-details="auto" dense v-model="handleAddress" :label="$t('address')" required
                :rules="[v => !!v || 'Item is required']">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="6" sm="6">
              <v-text-field outlined hide-details="auto" dense v-model="handleCity" :label="$t('city')" disabled>
              </v-text-field>
            </v-col>
            <v-col class="d-flex pa-1" cols="6" sm="6">
              <v-text-field outlined hide-details="auto" dense v-model="handleState" :label="$t('state')" disabled>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="6" sm="6">
              <v-text-field outlined hide-details="auto" dense v-model="handleZip" :label="$t('zip')" disabled>
              </v-text-field>
            </v-col>
            <v-col class="d-flex pa-1" cols="6" sm="6">
              <v-text-field outlined hide-details="auto" dense v-model="handleCountry" :label="$t('country')" disabled>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="12" sm="12">
              <div class="pt-4">
                <h5 class="heading text-left">{{ $t('contact') }}</h5>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="12" sm="12">
              <v-text-field outlined hide-details="auto" dense v-model="handleContactPerson"
                :rules="[v => !!v || 'Item is required']" :label="$t('contact-person')" required>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pa-1" cols="12" sm="12">
              <v-text-field outlined hide-details="auto" dense v-model="handleContactPhone"
                :rules="[v => !!v || 'Item is required']" :label="$t('contact-phone')" @input="formatPhoneNumber"
                required>
              </v-text-field>
              <v-text-field class="ml-2" outlined hide-details="auto" dense v-model="handleContactEmail"
                :rules="[v => !!v || 'Item is required']" :label="$t('contact-email')" required>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-5">
            <v-col cols="12" class="ma-0 pa-0">
              <v-checkbox class="ma-0 pa-0" v-model="dailyReminder" :label="$t('daily-reminder')" />
            </v-col>
            <v-col cols="12" class="ma-0 pa-0">
              <v-checkbox class="ma-0 pa-0" v-model="daylyMeasurementsReportDone"
                :label="$t('daily-measurements-report-done')" />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <div v-if="ecpLocationMapping !== null && (roleName === 'SYSTEM_ADMIN' || roleName === 'SYSTEM_USER')">
        <v-row>
          <v-col class="d-flex pa-1 mt-3" cols="6" sm="6">
            <div :key="refreshKey" class="d-flex flex-column pl-3">
              <span class="font-weight-bold color-black">{{ $t('migrate-users') }}</span>
              <v-btn-toggle @change="doAutomaticEcpUsersMapping"
                v-model="ecpLocationMapping.userCreationIsAutomaticValue" row active-class="chips white--text" mandatory
                class="white">
                <v-btn class="tabs-class" :value="0"
                  :input-value="ecpLocationMapping.userCreationIsAutomaticValue">{{ $t('manual') }}</v-btn>
                <v-btn class="tabs-class" :value="1"
                  :input-value="ecpLocationMapping.userCreationIsAutomaticValue">{{ $t('automatic') }}</v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
          <v-col class="d-flex pa-1 mt-3" cols="6" sm="6">
            <div :key="refreshKey" class="d-flex flex-column pl-3">
              <span class="font-weight-bold color-black">{{ $t('migrate-residents') }}</span>
              <v-btn-toggle @change="doAutomaticEcpResidentsMapping"
                v-model="ecpLocationMapping.residentCreationIsAutomaticValue" row active-class="chips white--text"
                mandatory class="white">
                <v-btn class="tabs-class" :value="0"
                  :input-value="ecpLocationMapping.residentCreationIsAutomaticValue">{{ $t('manual') }}</v-btn>
                <v-btn class="tabs-class" :value="1"
                  :input-value="ecpLocationMapping.residentCreationIsAutomaticValue">{{ $t('automatic') }}</v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="false">
          <v-col class="d-flex pa-1 mt-3" cols="6" sm="6">
            <div :key="refreshKey" class="d-flex flex-column pl-3">
              <span class="font-weight-bold color-black">{{ $t('send-measurements-to-emar') }}</span>
              <v-btn-toggle @change="doFinalizeMeasurmentsAutomatically"
                v-model="ecpLocationMapping.finalizeMeasurementAutomaticallyValue" row active-class="chips white--text"
                mandatory class="white">
                <v-btn class="tabs-class" :value="0"
                  :input-value="ecpLocationMapping.finalizeMeasurementAutomaticallyValue">{{ $t('manual') }}</v-btn>
                <v-btn class="tabs-class" :value="1"
                  :input-value="ecpLocationMapping.finalizeMeasurementAutomaticallyValue">{{ $t('automatic') }}</v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-card-actions class="fixed-card-actions">
      <v-row class="mb-0">
        <v-col cols="6">
          <v-btn @click="closeDrawer" elevation="0" class="cancel-button-style capitalize-text">
            {{ $t('cancel') }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn :disabled="!valid" @click="saveHospital" class="save-button-style">
            {{ $t('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { showSuccessAlert, showErrorAlert } from '@/utils/utilities';
import { AsYouType } from 'libphonenumber-js';
import HospitalsRepository from '@/data/repositories/v1/HospitalsRepository';

export default {
  name: 'HospitalEditDrawerDialog',
  components: {},
  data: () => ({
    refreshKey: 0,
    valid: true,
    measurement: 0,
    menu: false,
    hospitalName: '',
    selectedOrganization: null,
    description: '',
    ecpLocationMapping: null,
    defaultTimeZone: 'America/Chicago',
  }),
  mounted () {
    this.getEcpMappingLocation();
  },

  computed: {
    ...mapGetters({
      delay: 'authentication/getDelay',
      appBarSearch: 'filterbar/getSearch',
      appBarMedicalInstitution: 'filterbar/getMedicalInstitution',
      roleName: 'authentication/getRole',
    }),
    ...mapState({
      updateDrawer: (state) => state.updateDrawer,
      allMedicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
      hospitals: (state) => state.hospitals.hospitals,
      allVerifiers: (state) => state.verifiers.allverifires,
      selectedHospital: (state) => state.hospitals.selectedHospital,
    }),
    handleDescription: {
      get () {
        return this.selectedHospital?.description || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.description = value;
        }
      },
    },
    handleMedicalInstitutionId: {
      get () {
        return this.selectedHospital?.medicalInstitutionId || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.medicalInstitutionId = value;
        }
      },
    },
    handleAddress: {
      get () {
        return this.selectedHospital?.address || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.address = value;
        }
      },
    },
    handleHospitalName: {
      get () {
        return this.selectedHospital?.hospitalName || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.hospitalName = value;
        }
      },
    },
    handleContactPhone: {
      get () {
        return this.selectedHospital?.contactPhone || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.contactPhone = value;
        }
      },
    },
    handleContactEmail: {
      get () {
        return this.selectedHospital?.contactEmail || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.contactEmail = value;
        }
      },
    },
    handleContactPerson: {
      get () {
        return this.selectedHospital?.contactPerson || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.contactPerson = value;
        }
      },
    },
    handleCountry: {
      get () {
        return this.selectedHospital?.country || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.country = value;
        }
      },
    },
    handleState: {
      get () {
        return this.selectedHospital?.state || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.state = value;
        }
      },
    },
    handleZip: {
      get () {
        return this.selectedHospital?.zip || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.zip = value;
        }
      },
    },
    handleCity: {
      get () {
        return this.selectedHospital?.city || '';
      },
      set (value) {
        if (this.selectedHospital) {
          this.selectedHospital.city = value;
        }
      },
    },
    dailyReminder: {
      get () {
        return JSON.parse(this.selectedHospital?.notificationSettings)?.dailyReportNotification?.dailyReminder || false;
      },
      set (value) {
        const updateObject = { dailyReportNotification: { dailyReminder: value || false, daylyMeasurementsReportDone: JSON.parse(this.selectedHospital.notificationSettings)?.dailyReportNotification?.daylyMeasurementsReportDone || false } };
        this.selectedHospital.notificationSettings = JSON.stringify(updateObject);
      },
    },
    daylyMeasurementsReportDone: {
      get () {
        return JSON.parse(this.selectedHospital?.notificationSettings)?.dailyReportNotification?.daylyMeasurementsReportDone || false;
      },
      set (value) {
        const updateObject = { dailyReportNotification: { dailyReminder: JSON.parse(this.selectedHospital?.notificationSettings)?.dailyReportNotification?.dailyReminder || false, daylyMeasurementsReportDone: value || false } };
        this.selectedHospital.notificationSettings = JSON.stringify(updateObject);
      },
    },
  },
  watch: {
    updateDrawer: {
      handler (newVal) {
        if (newVal) {
          this.getEcpMappingLocation();
        }
      },
      deep: true,
    },
  },
  methods: {
    doAutomaticEcpUsersMapping () {
      var body = {
        hospitalId: this.selectedHospital.id,
        mappEcpUsersAutomatically: this.ecpLocationMapping.userCreationIsAutomaticValue === 1,
      };

      HospitalsRepository.doAutomaticEcpUsersMapping(body).then((res) => {
        this.ecpLocationMapping = res.data;
        this.ecpLocationMapping.userCreationIsAutomaticValue = this.ecpLocationMapping.userCreationIsAutomatic ? 1 : 0;
        this.ecpLocationMapping.residentCreationIsAutomaticValue = this.ecpLocationMapping.residentCreationIsAutomatic ? 1 : 0;
        this.ecpLocationMapping.finalizeMeasurementAutomaticallyValue = this.ecpLocationMapping.finalizeMeasurementAutomatically ? 1 : 0;
        this.refreshKey += 1;
      });
    },

    doAutomaticEcpResidentsMapping () {
      var body = {
        hospitalId: this.selectedHospital.id,
        mappEcpResidentsAutomatically: this.ecpLocationMapping.residentCreationIsAutomaticValue === 1,
      };
      HospitalsRepository.doAutomaticEcpResidentsMapping(body).then((res) => {
        this.ecpLocationMapping = res.data;
        this.ecpLocationMapping.userCreationIsAutomaticValue = this.ecpLocationMapping.userCreationIsAutomatic ? 1 : 0;
        this.ecpLocationMapping.residentCreationIsAutomaticValue = this.ecpLocationMapping.residentCreationIsAutomatic ? 1 : 0;
        this.ecpLocationMapping.finalizeMeasurementAutomaticallyValue = this.ecpLocationMapping.finalizeMeasurementAutomatically ? 1 : 0;
        this.refreshKey += 1;
      });
    },

    doFinalizeMeasurmentsAutomatically () {
      var body = {
        hospitalId: this.selectedHospital.id,
        finalizeMeasurmentsAutomatically: this.ecpLocationMapping.finalizeMeasurementAutomaticallyValue === 1,
      };
      HospitalsRepository.doFinalizeMeasurmentsAutomatically(body).then((res) => {
        this.ecpLocationMapping = res.data;
        this.ecpLocationMapping.userCreationIsAutomaticValue = this.ecpLocationMapping.userCreationIsAutomatic ? 1 : 0;
        this.ecpLocationMapping.residentCreationIsAutomaticValue = this.ecpLocationMapping.residentCreationIsAutomatic ? 1 : 0;
        this.ecpLocationMapping.finalizeMeasurementAutomaticallyValue = this.ecpLocationMapping.finalizeMeasurementAutomatically ? 1 : 0;
        this.refreshKey += 1;
      });
    },
    getEcpMappingLocation () {
      if (this.roleName === 'SYSTEM_ADMIN' || this.roleName === 'SYSTEM_USER') {
        this.$store.dispatch('hospitals/getEcpMappingLocation', this.selectedHospital.id).then((res) => {
          this.ecpLocationMapping = null;
          if (res.data) {
            this.ecpLocationMapping = res.data;
            this.ecpLocationMapping.userCreationIsAutomaticValue = this.ecpLocationMapping.userCreationIsAutomatic ? 1 : 0;
            this.ecpLocationMapping.residentCreationIsAutomaticValue = this.ecpLocationMapping.residentCreationIsAutomatic ? 1 : 0;
            this.ecpLocationMapping.finalizeMeasurementAutomaticallyValue = this.ecpLocationMapping.finalizeMeasurementAutomatically ? 1 : 0;
          }
        });
      }
    },
    formatPhoneNumber (val) {
      this.selectedHospital.contactPhone = new AsYouType().input(val);
    },
    setSelectedOrganization (val) {
      this.selectedOrganization = this.allMedicalInstitutions.find(org => org.id === val);

      this.selectedHospital.address = this.selectedOrganization.address;
      this.selectedHospital.city = this.selectedOrganization.city;
      this.selectedHospital.state = this.selectedOrganization.state;
      this.selectedHospital.zip = this.selectedOrganization.zip;
      this.selectedHospital.country = this.selectedOrganization.country;
    },
    async getHospitals () {
      await this.$store.dispatch('hospitals/getHospitals').then(() => {
        // after filtering
        // const selectedMedicalInstitutionId = this.appBarMedicalInstitution;
        // if (selectedMedicalInstitutionId === 0 || selectedMedicalInstitutionId === undefined || selectedMedicalInstitutionId === null) {
        // 	this.$store.commit('hospitals/GET_HOSPITALS_V2', this.hospitals); // get from the store, not from API call - refresh list with all hospitals
        // } else {
        // 	var hospitalsForMedicalInstitution = this.hospitals?.filter(h => h.medicalInstitutionId === selectedMedicalInstitutionId);
        // 	this.$store.commit('hospitals/GET_HOSPITALS_FILTERED', hospitalsForMedicalInstitution); // filter the hospitals list by selected organization
        // }
        this.closeDrawer();
      });
    },
    async saveHospital () {
      await this.checkAndFixLocationDetails();
      if (this.$refs.form.validate()) {
        const body = {
          id: this.selectedHospital.id,
          medicalInstitutionId: this.selectedHospital.medicalInstitutionId,
          hospitalName: this.selectedHospital.hospitalName,
          description: this.selectedHospital.description,
          contactPerson: this.selectedHospital.contactPerson,
          contactPhone: this.selectedHospital.contactPhone,
          contactEmail: this.selectedHospital.contactEmail,
          address: this.selectedHospital?.address,
          zip: this.selectedHospital?.zip,
          city: this.selectedHospital?.city,
          state: this.selectedHospital?.state,
          country: this.selectedHospital?.country,
          addressLatitude: this.selectedHospital?.addressLatitude,
          addressLongitude: this.selectedHospital?.addressLongitude,
          mediaServerData: this.selectedHospital.mediaServerData,
          hospitalSpetializationId: this.hospitalSpetializationId,
          hospitalTimezone: this.selectedHospital.hospitalTimeZone,
          notificationSettings: this.selectedHospital.notificationSettings,

        };
        await this.$store.dispatch('hospitals/editHospital', body)
          .then((res) => {
            if (res) {
              showSuccessAlert(this.$t('success-operation'));
              this.getHospitals(); // reload the list of organizations
            } else {
              showErrorAlert(this.$t('failed-operation'));
            }
          });
      } else {
        this.$refs.form.validate();
      }
    },
    save (date) {
      this.$refs.menu.save(date);
    },
    closeDrawer () {
      this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
      this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
    },

    async checkAndFixLocationDetails () {
      try {
        const h = this.selectedHospital;

        if (h.address) {
          const addressForValidation = `${h.address}`;
          const geoLocation = await this.$store.dispatch('googleAPI/getGeoLocation', addressForValidation);

          if (!geoLocation || !geoLocation.address_components || !geoLocation.geometry) {
            h.addressLatitude = 0.01;
            h.addressLongitude = 0.01;
            return false;
          }

          const components = geoLocation.address_components;
          const getComponent = (type) => {
            const found = components.find(c => c.types.includes(type));
            return found ? found.long_name : 'N/A';
          };

          // Extract and set location info
          const lat = geoLocation.geometry.location.lat || 0.01;
          const lng = geoLocation.geometry.location.lng || 0.01;

          h.addressLatitude = lat;
          h.addressLongitude = lng;
          h.address = geoLocation.formatted_address || h.address;
          h.city = getComponent('locality') || getComponent('sublocality') || getComponent('administrative_area_level_2') || 'N/A';
          h.state = getComponent('administrative_area_level_1') || 'N/A';
          h.country = getComponent('country') || 'N/A';
          h.zip = getComponent('postal_code') || 'N/A';

          // Now call Time Zone API
          const timestamp = Math.floor(Date.now() / 1000); // current time in seconds
          const timeZoneResponse = await fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.VUE_APP_GOOGLEMAPAPIKEY}`);
          const timeZoneData = await timeZoneResponse.json();

          if (timeZoneData.status === 'OK') {
            h.timeZoneId = timeZoneData.timeZoneId; // e.g., "Europe/Skopje"
            h.timeZoneName = timeZoneData.timeZoneName; // e.g., "Central European Summer Time"
            h.rawOffset = timeZoneData.rawOffset; // base offset in seconds
            h.dstOffset = timeZoneData.dstOffset; // daylight savings offset in seconds
            h.hospitalTimeZone = timeZoneData.timeZoneId;
          } else {
            // If timezone fetch failed, set default or null
            h.timeZoneId = 'N/A';
            h.timeZoneName = 'N/A';
            h.rawOffset = 0;
            h.dstOffset = 0;
            h.hospitalTimeZone = this.defaultTimeZone;
          }

          return true;
        } else {
          h.addressLatitude = 0.01;
          h.addressLongitude = 0.01;
          return false;
        }
      } catch (error) {
        this.selectedHospital.addressLatitude = 0.01;
        this.selectedHospital.addressLongitude = 0.01;
        this.selectedHospital.hospitalTimeZone = this.defaultTimeZone;
        return false;
      }
    },
  },
};
</script>
